import * as yup from 'yup';

import { GeneralAssemblyAccess } from '../types/generalAssemblyAccess';

export const generalAssemblyAccessSchema = yup
  .object({
    generalAssemblyId: yup.string().uuid().required(),
    coOwnerId: yup.string().required(),
    syndicId: yup.string().required(),
    userId: yup.string().required(),
    status: yup
      .mixed<GeneralAssemblyAccess['status']>()
      .oneOf(['ACTIVE', 'REVOKED'])
      .required(),
    updatedAt: yup.mixed().optional(),
  })
  .required();
